import window1G from "../images/calc-1-G.jpg";
import window1PO from "../images/calc-1-PO.jpg";
import window2GG from "../images/calc-2-G-G.jpg";
import window2GPO from "../images/calc-2-G-PO.jpg";
import window2POPO from "../images/calc-2-PO-PO.jpg";
import window3GGG from "../images/calc-3-G-G-G.jpg";
import window3GPOG from "../images/calc-3-G-PO-G.jpg";
import window3POPO from "../images/calc-3-PO-G-PO.jpg";
import windowTGG from "../images/calc-T-G-G.jpg";
import windowTGPO from "../images/calc-T-G-PO.jpg";
import windowTPOPO from "../images/calc-T-PO-PO.jpg";
import windowTGPOG from "../images/calc-T-G-PO-G.jpg";
import window4GPOPOG from "../images/calc-4-G-PO-PO-G.jpg";
import window4POGGPO from "../images/calc-4-PO-G-G-PO.jpg";
import balkPO from "../images/calc-balk-PO.jpg";
import door1PO from "../images/calc-D1-PO.jpg";
import door2PO from "../images/calc-D2-PO.jpg";

export const images = [
  [
    [door1PO],
    [door2PO]
  ],
  [
    [window1G, window1PO],
    [window2GG, window2GPO, window2POPO],
    [window3GGG, window3GPOG, window3POPO],
    [windowTGG, windowTGPO, windowTPOPO, windowTGPOG],
    [window4GPOPOG, window4POGGPO],
    [balkPO]
  ]
];

export const oImages = [
  window1PO,
  window2GPO,
  window3GPOG,
  windowTGPO,
  window4GPOPOG,
  balkPO,
  door1PO,
  door2PO
];

export const windowNames = [
  "Одностворчатое окно",
  "Двухстворчатое окно",
  "Трёхстворчатое окно",
  "T-образное окно",
  "Балконная рама",
  "Балконная дверь"
];
export const doorNames = [
  "Одностворчатая дверь",
  "Двухстворчатая дверь",
];

export const profiles = [
  [
    "Rehau дверная створка, 70мм",
    "Oras R-Line Eco 70 дверная створка",
    "Oras R-Line Eco 60 дверная створка",
    "Brusbox оконная створка (Class A), 70мм",
    "Brusbox оконная створка (Class A), 60мм",
    "Brusbox дверная створка (Class A), 70мм",
    "Brusbox дверная створка (Class A), 60мм"
  ],
  [
    "Oras R-Line Eco 60 (1-кам. стеклопакет)",
    "Oras R-Line Eco 60 (2-кам. стеклопакет)",
    "Oras R-Line 70 (1-кам. стеклопакет)",
    "Oras R-Line 70 (2-кам. стеклопакет)",
    "Brusbox Aero 60-3 (1-кам. стеклопакет)",
    "Brusbox Aero 60-3 (2-кам. стеклопакет)",
    "Brusbox Super Aero 70-5 (1-кам. стеклопакет)",
    "Brusbox Super Aero 70-5 (2-кам. стеклопакет)",
    "Brusbox 70-6 Class A (2-кам. стеклопакет)",
    "Rehau Blitz 60-3 (2-кам. стеклопакет)",
    "Rehau Grazio 70-5 (2-кам. стеклопакет)",
  ]
];
export const profileLinks = [
  [
    "https://oknagomel.by/profil-dlya-dverej-70-mm",
    "https://oknagomel.by/profil-dlya-dverej-70-mm",
    "https://oknagomel.by/profil-dlya-dverej-60-mm",
    "https://oknagomel.by/profil-dlya-dverej-70-mm",
    "https://oknagomel.by/profil-dlya-dverej-60-mm",
    "https://oknagomel.by/profil-dlya-dverej-70-mm",
    "https://oknagomel.by/profil-dlya-dverej-60-mm"
  ],
  [
    "https://oknagomel.by/oras-r-line-eco-60",
    "https://oknagomel.by/oras-r-line-eco-60",
    "https://oknagomel.by/oras-r-line-70",
    "https://oknagomel.by/oras-r-line-70",
    "https://oknagomel.by/brusbox-aero",
    "https://oknagomel.by/brusbox-aero",
    "https://oknagomel.by/brusbox-70-5-class-b",
    "https://oknagomel.by/brusbox-70-5-class-b",
    "https://oknagomel.by/brusbox-70-6-class-a",
    "https://oknagomel.by/rehau-blitz",
    "https://oknagomel.by/rehau-grazio",
  ]
]

export const widths = [
  [
    [
      [600, 700, 800, 900, 1000]
    ],
    [
      [1200, 1300, 1400, 1500, 1600, 1700, 1800, 1900, 2000]
    ]
  ],
  [
    [
      [500, 600, 700, 800, 900, 1000, 1100, 1200, 1300, 1400, 1500, 1600, 1700, 1800],
      [500, 600, 700, 800, 900, 1000]
    ],
    [
      [600, 700, 800, 900, 1000, 1100, 1200, 1300, 1400, 1500, 1600, 1700, 1800, 1900],
      [1000, 1100, 1200, 1300, 1400, 1500, 1600, 1700, 1800, 1900, 2000],
      [1000, 1100, 1200, 1300, 1400, 1500, 1600, 1700, 1800, 1900, 2000]
    ],
    [
      [1600, 1700, 1800, 1900, 2000, 2100, 2200, 2300, 2400, 2500, 2600, 2700, 2800, 2900],
      [1600, 1700, 1800, 1900, 2000, 2100, 2200, 2300, 2400, 2500, 2600, 2700, 2800, 2900],
      [1600, 1700, 1800, 1900, 2000, 2100, 2200, 2300, 2400, 2500, 2600, 2700, 2800, 2900]
    ],
    [
      [1000, 1100, 1200, 1300, 1400, 1500, 1600, 1700, 1800, 1900, 2000, 2100, 2200, 2300],
      [1000, 1100, 1200, 1300, 1400, 1500, 1600, 1700, 1800, 1900, 2000, 2100],
      [1000, 1100, 1200, 1300, 1400, 1500, 1600, 1700, 1800, 1900, 2000, 2100],
      [1700, 1800, 1900, 2000, 2100, 2200, 2300, 2400, 2500, 2600, 2700, 2800, 2900, 3000]
    ],
    [
      [2100, 2200, 2300, 2400, 2500, 2600, 2700, 2800, 2900, 3000, 3100, 3200, 3300, 3400],
      [2100, 2200, 2300, 2400, 2500, 2600, 2700, 2800, 2900, 3000, 3100, 3200, 3300, 3400]
    ],
    [
      [600, 700, 800, 900, 1000]
    ]
  ]
]; 
export const heights = [
  [
    [
      [1800, 1900, 2000, 2100, 2200, 2300, 2400, 2500, 2600]
    ],
    [
      [1800, 1900, 2000, 2100, 2200, 2300, 2400, 2500, 2600]
    ]
  ],
  [
    [
      [500, 600, 700, 800, 900, 1000, 1100, 1200, 1300, 1400, 1500, 1600, 1700, 1800, 1900, 2000, 2100, 2200, 2300],
      [800, 900, 1000, 1100, 1200, 1300, 1400, 1500, 1600, 1700, 1800, 1900, 2000, 2100, 2200]
    ],
    [
      [500, 600, 700, 800, 900, 1000, 1100, 1200, 1300, 1400, 1500, 1600, 1700, 1800, 1900, 2000, 2100, 2200, 2300],
      [800, 900, 1000, 1100, 1200, 1300, 1400, 1500, 1600, 1700, 1800, 1900, 2000, 2100, 2200],
      [800, 900, 1000, 1100, 1200, 1300, 1400, 1500, 1600, 1700, 1800, 1900, 2000, 2100, 2200]
    ],
    [
      [800, 900, 1000, 1100, 1200, 1300, 1400, 1500, 1600, 1700, 1800, 1900, 2000, 2100, 2200, 2300],
      [800, 900, 1000, 1100, 1200, 1300, 1400, 1500, 1600, 1700, 1800, 1900, 2000, 2100, 2200],
      [800, 900, 1000, 1100, 1200, 1300, 1400, 1500, 1600, 1700, 1800, 1900, 2000, 2100, 2200]
    ],
    [
      [1000, 1100, 1200, 1300, 1400, 1500, 1600, 1700, 1800, 1900, 2000, 2100, 2200, 2300, 2400, 2500, 2600],
      [1000, 1100, 1200, 1300, 1400, 1500, 1600, 1700, 1800, 1900, 2000, 2100, 2200, 2300, 2400, 2500, 2600],
      [1000, 1100, 1200, 1300, 1400, 1500, 1600, 1700, 1800, 1900, 2000, 2100, 2200, 2300, 2400, 2500, 2600],
      [1000, 1100, 1200, 1300, 1400, 1500, 1600, 1700, 1800, 1900, 2000, 2100, 2200, 2300, 2400, 2500]
    ],
    [
      [800, 900, 1000, 1100, 1200, 1300, 1400, 1500, 1600, 1700, 1800, 1900, 2000, 2100, 2200],
      [800, 900, 1000, 1100, 1200, 1300, 1400, 1500, 1600, 1700, 1800, 1900, 2000, 2100, 2200]
    ],
    [
      [1800, 1900, 2000, 2100, 2200, 2300, 2400, 2500]
    ]
  ]
];

export const opensA = [
  [
    [1],
    [2]
  ],
  [
    [0, 1],
    [0, 1, 2],
    [0, 1, 2],
    [0, 1, 2, 1],
    [2, 2],
    [1]
  ]
]

export const optionNames = [
  [
    ["одно открывание"],
    ["два открывания"],
  ],
  [
    ["глухое", "одно открывание"],
    ["глухое", "одно открывание", "два открывания"],
    ["глухое", "одно открывание", "два открывания"],
    ["глухое", "одно открывание", "два открывания", "одно открывание"],
    ["два открывания (центр)", "два открывания (бока)"],
    ["одно открывание"]
  ]
];
export const arcNames = ["KALE", "ROTO"];
export const depthNames = ["однокамерный", "двухкамерный"];

export const HTTPBot = "7194595697:AAEclCmGyBK1G0c0RBf-CXVnB5e9GAoMHbM";
export const chatId = [
  "315813735",
  //"2123399802",
  "960764984",
  "130773975",
];